// theme/customizations/card.js

export const cardCustomizations = {
  MuiCard: {
    styleOverrides: {
      root: ({ theme }) => ({
        display: "flex",
        flexDirection: "column",
        alignSelf: "center",
        width: "100%",
        padding: theme.spacing(4),
        gap: theme.spacing(2),
        margin: "auto",
        [theme.breakpoints.up("sm")]: {
          maxWidth: 450,
        },
        borderRadius: 6, // ← Try 4 or 6 for subtle rounding
        boxShadow:
          "hsla(220, 30%, 5%, 0.05) 0px 5px 15px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px",
      }),
    },
  },
};
